import React, { useEffect, useState } from 'react';

const ORGS = ['NCAR', 'NOAA', 'NASA', 'USGS', 'NSF'];

const FACTS = [
  { value: '9', unit: 'yrs', label: 'At NCAR' },
  { value: '3M+', unit: '', label: 'Stream channels forecast' },
  { value: '65', unit: 'TB', label: 'Climate data pipeline' },
  { value: '18', unit: '', label: 'Publications' },
];

const SOCIALS = [
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/in/ishita-srivastava-8aa66899/',
    path: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z',
  },
  {
    label: 'Google Scholar',
    href: 'https://scholar.google.com/citations?user=xY8c1x8AAAAJ&hl=en',
    path: 'M5.242 13.769L0 9.5 12 0l12 9.5-5.242 4.269C17.548 11.249 14.978 9.5 12 9.5c-2.977 0-5.548 1.748-6.758 4.269zM12 10a7 7 0 1 0 0 14 7 7 0 0 0 0-14z',
  },
  {
    label: 'Aerveil on YouTube',
    href: 'https://www.youtube.com/@Aerveil-ai',
    path: 'M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z',
  },
  {
    label: 'Aerveil on Instagram',
    href: 'https://www.instagram.com/aerveil.ai/',
    path: 'M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.336 3.608 1.311.975.975 1.249 2.242 1.311 3.608.058 1.266.07 1.646.07 4.85s-.012 3.584-.07 4.85c-.062 1.366-.336 2.633-1.311 3.608-.975.975-2.242 1.249-3.608 1.311-1.266.058-1.646.07-4.85.07s-3.584-.012-4.85-.07c-1.366-.062-2.633-.336-3.608-1.311-.975-.975-1.249-2.242-1.311-3.608-.058-1.266-.07-1.646-.07-4.85s.012-3.584.07-4.85c.062-1.366.336-2.633 1.311-3.608.975-.975 2.242-1.249 3.608-1.311 1.266-.058 1.646-.07 4.85-.07zM12 0C8.741 0 8.332.014 7.052.072 5.197.157 3.355.673 2.014 2.014.673 3.355.157 5.197.072 7.052.014 8.332 0 8.741 0 12s.014 3.668.072 4.948c.085 1.855.601 3.697 1.942 5.038 1.341 1.341 3.183 1.857 5.038 1.942C8.332 23.986 8.741 24 12 24s3.668-.014 4.948-.072c1.855-.085 3.697-.601 5.038-1.942 1.341-1.341 1.857-3.183 1.942-5.038.058-1.28.072-1.689.072-4.948s-.014-3.668-.072-4.948c-.085-1.855-.601-3.697-1.942-5.038C20.645.673 18.803.157 16.948.072 15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z',
  },
];

const Hero = () => {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    setShown(true);
  }, []);

  const rise = (delay) =>
    `transition-all duration-1000 ease-calm ${delay} ${
      shown ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
    }`;

  return (
    <section id="top" className="relative overflow-hidden bg-night text-cream">
      {/* A single warm wash from the top left, standing in for the dawn light
          on aerveil.ai. One gradient, not six. */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            'radial-gradient(120% 90% at 12% 0%, rgba(224,173,42,0.13) 0%, rgba(224,173,42,0.04) 34%, transparent 66%)',
        }}
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-b from-transparent to-cream/[0.06]"
      />

      <div className="shell relative flex min-h-screen flex-col justify-center pb-20 pt-32 md:pb-28 md:pt-36">
        <div className="grid items-end gap-14 lg:grid-cols-12 lg:gap-12">
          {/* Left: the name and the claim */}
          <div className="lg:col-span-7">
            <div className={`flex items-baseline gap-3 ${rise('delay-100')}`}>
              <span className="font-mono text-[0.7rem] tracking-eyebrow text-amber-bright">
                00
              </span>
              <span className="eyebrow text-cream/45">San Jose, CA</span>
            </div>

            <h1 className={`display-xl mt-7 ${rise('delay-200')}`}>
              Ishita
              <br />
              Srivastava
            </h1>

            <div className={`mt-8 flex flex-wrap items-center gap-x-3 gap-y-2 ${rise('delay-300')}`}>
              <span className="font-mono text-xs uppercase tracking-eyebrow text-amber-bright">
                Founder and CEO
              </span>
              {/* Middot, not a rule. The previous h-px separator rendered as an
                  em dash even though no em dash character was present. */}
              <span aria-hidden="true" className="font-mono text-xs text-cream/40">
                ·
              </span>
              <a
                href="https://aerveil.ai"
                target="_blank"
                rel="noopener noreferrer"
                className="link-underline font-mono text-xs uppercase tracking-eyebrow text-cream"
              >
                Aerveil.ai
              </a>
            </div>

            <p className={`lede mt-9 text-cream/75 ${rise('delay-[400ms]')}`}>
              Founded Aerveil, which makes the frost and spray call for Napa vineyards, block by
              block. Before that, nine years at the National Center for Atmospheric Research,
              building the operational weather and hydrology systems that NOAA, NASA and the
              USGS run on.
            </p>

            <div className={`mt-11 flex flex-wrap items-center gap-3 ${rise('delay-500')}`}>
              <a href="#aerveil" className="btn-amber">
                What I am building
              </a>
              <a href="#work" className="btn-ghost-cream">
                Selected work
              </a>
            </div>

            {/* Social row */}
            <div className={`mt-12 flex items-center gap-5 ${rise('delay-700')}`}>
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={s.label}
                  aria-label={s.label}
                  className="text-cream/45 transition-colors duration-300 hover:text-amber-bright"
                >
                  <svg className="h-[1.15rem] w-[1.15rem]" fill="currentColor" viewBox="0 0 24 24">
                    <path d={s.path} />
                  </svg>
                </a>
              ))}
            </div>
          </div>

          {/* Right: portrait */}
          <div className={`lg:col-span-5 ${rise('delay-300')}`}>
            <div className="relative ml-auto w-full max-w-[22rem]">
              {/* The real background, faded back toward the panel colour rather
                  than cut away. Every cutout attempt left a visible hairline where
                  the matte met the panel, because the matte edge is never exactly
                  right on hair. Keeping the room and fading it means both sides of
                  that boundary stay visible, so there is no edge to get wrong. The
                  cream panel underneath is just the ground while the image loads. */}
              <div className="bg-cream">
                <img
                  src="/img/portrait-hero.webp"
                  alt="Ishita Srivastava"
                  width="704"
                  height="832"
                  /* Natural sizing, no object-cover: the asset's aspect is baked to
                     match this column. */
                  className="block h-auto w-full"
                />
              </div>

              {/* Credential badge, overlapping the portrait corner */}
              <img
                src="/img/claude-certified-architect.png"
                alt="Claude Certified Architect, Foundations"
                width="604"
                height="604"
                className="absolute -bottom-7 -left-7 h-24 w-24 drop-shadow-xl md:h-28 md:w-28"
              />

              <div className="mt-4 flex items-center justify-end">
                <span className="font-mono text-[0.68rem] tracking-eyebrow text-cream/40">
                  MS CS, CU Boulder
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Facts strip */}
        <div className={`mt-20 border-t border-cream/15 pt-8 ${rise('delay-[800ms]')}`}>
          <dl className="grid grid-cols-2 gap-x-6 gap-y-8 md:grid-cols-4">
            {FACTS.map((f) => (
              <div key={f.label}>
                <dt className="sr-only">{f.label}</dt>
                <dd>
                  <span className="figure text-3xl text-cream md:text-4xl">{f.value}</span>
                  {f.unit && (
                    <span className="figure ml-1 text-sm text-amber-bright">{f.unit}</span>
                  )}
                  <span className="mt-2 block font-mono text-[0.68rem] uppercase tracking-eyebrow text-cream/45">
                    {f.label}
                  </span>
                </dd>
              </div>
            ))}
          </dl>
        </div>

        {/* Organisations. Names only, no agency insignia: NOAA, NASA and NSF all
            restrict third-party use of their marks, and a row of official seals on
            a site that also markets Aerveil is close to what those policies
            describe. The names themselves are plain fact. "Systems for" rather
            than "built for" keeps it about the work rather than affiliation. */}
        <div className={`mt-14 ${rise('delay-[900ms]')}`}>
          <p className="eyebrow text-cream/35">Systems for</p>
          <ul className="mt-4 flex flex-wrap items-center gap-y-3">
            {ORGS.map((o, i) => (
              <li key={o} className="flex items-center">
                {i > 0 && (
                  <span aria-hidden="true" className="mx-5 h-4 w-px bg-cream/20 md:mx-6" />
                )}
                <span className="font-mono text-base tracking-[0.14em] text-cream/75 md:text-lg">
                  {o}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Hero;
